import {fetchSubscription} from './subscription'

export default {
    fetchSubscription,
}
